import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-40df508e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "logo",
    src: _imports_0,
    style: {"width":"240px"},
    class: "p-mr-2"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PanelMenu = _resolveComponent("PanelMenu")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_PanelMenu, { model: $setup.appMenu }, null, 8, ["model"]),
    (!$props.isLoggedIn)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: { name: 'login' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              label: "Đăng nhập",
              icon: "pi pi-sign-in",
              iconPos: "right"
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          label: "Đăng xuất",
          onClick: $setup.logout,
          icon: "pi pi-sign-out",
          iconPos: "right",
          class: "p-button-secondary"
        }, null, 8, ["onClick"]))
  ], 64))
}